import { render, staticRenderFns } from "./FunctionHistoryTab.vue?vue&type=template&id=8bbf19ae&scoped=true&lang=pug"
import script from "./FunctionHistoryTab.vue?vue&type=script&lang=ts"
export * from "./FunctionHistoryTab.vue?vue&type=script&lang=ts"
import style0 from "./FunctionHistoryTab.vue?vue&type=style&index=0&id=8bbf19ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbf19ae",
  null
  
)

export default component.exports